import { Injectable, NgZone } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { Item } from 'src/app/models/liveshop';
import { VideoItem } from 'src/app/models/video-item.model';

export interface VideoModalState {
  show: boolean;
  selectedVideo: VideoItem | null;
  playerSlicks: Item[];
  slicks: Item[];
  totalAssets: number;
  isAdmin: boolean;
  widgetId?: number;
  storeId?: number;
  templateId?: number;
  height?: number;
  pageToVideos?: number;
  instanceId?: string;
}

export interface VideoModalOpenParams {
  video: VideoItem;
  slicks: Item[];
  totalAssets: number;
  isAdmin: boolean;
  widgetId?: number;
  storeId?: number;
  templateId?: number;
  height?: number;
  pageToVideos?: number;
  instanceId?: string;
}

const INITIAL_STATE: VideoModalState = {
  show: false,
  selectedVideo: null,
  playerSlicks: [],
  slicks: [],
  totalAssets: 0,
  isAdmin: true,
  widgetId: undefined,
  storeId: undefined,
  templateId: undefined,
  height: undefined,
  pageToVideos: 0,
  instanceId: undefined,
};

@Injectable({ providedIn: 'root' })
export class VideoModalService {
  private readonly stateSubject = new BehaviorSubject<VideoModalState>(INITIAL_STATE);
  readonly state$ = this.stateSubject.asObservable();

  constructor(private ngZone: NgZone) { }

  async open(params: VideoModalOpenParams): Promise<void> {
    const sorted = this.sortSlicks(params.slicks, params.video.uid);
    const playerSlicks = this.transformVideoToSlick(params.video);
    const slicksForState = sorted.length ? sorted : playerSlicks;

    //this.ngZone.run(() =>
    this.stateSubject.next({
      show: true,
      selectedVideo: params.video,
      playerSlicks,
      slicks: slicksForState,
      totalAssets: params.totalAssets,
      isAdmin: params.isAdmin,
      widgetId: params.widgetId,
      storeId: params.storeId,
      templateId: params.templateId,
      height: params.height,
      pageToVideos: params.pageToVideos,
      instanceId: params.instanceId,
    })
    //
  }

  close(instanceId?: string): void {
    const current = this.stateSubject.value;
    if (!current.show) {
      return;
    }

    const nextState: VideoModalState = {
      ...current,
      show: false,
      instanceId: current.instanceId ?? instanceId
    };
    this.stateSubject.next(nextState);
  }

  private sortSlicks(slicks: Item[], uid: string): Item[] {
    if (!slicks?.length) {
      return [];
    }

    const index = slicks.findIndex((item) => item?.content?.uid === uid);
    if (index === -1) {
      return [...slicks];
    }

    return [...slicks.slice(index), ...slicks.slice(0, index)];
  }

  private transformVideoToSlick(video: VideoItem): Item[] {
    return [
      {
        schedule: {
          date_from: new Date().toISOString(),
          date_to: null,
        },
        media: {
          type: 'video',
          src: video.src,
          pin: 0,
          time_to_pitch: '',
          thumbnail: video.thumbnail || null,
          duration: null,
          stream_status: null,
          status: 1,
          aspect_ratio: '16/9',
        },
        content: {
          id: video.id,
          uid: video.uid,
          title: video.title || 'Video',
          description: video.description || '',
          cta: {
            components: {
              custom: [],
              whatsapp: [],
              products: {
                items: video.products || [],
              },
              promotions: {
                items: [],
              },
              links: [],
              extra: {
                ecom_layer: {
                  cart: { type: null, display: null, platform: null },
                  search_bar: { display: null },
                },
                chat_box: { display: { read: null, write: null } },
                promotions: { items: [] },
                player: {
                  auto_play: true,
                  show_progress_bar: false,
                  time_to_pitch: false,
                  time_to_pitch_value: '',
                  player_color: '#000000',
                  progress_bar_color: '#FFFFFF',
                },
                tags: '',
                profileBtn: true,
              },
              alerts: [],
            },
          },
        },
        extra: {
          ecom_layer: {
            cart: { type: null, display: null, platform: null },
            search_bar: { display: null },
          },
          chat_box: { display: { read: null, write: null } },
          promotions: { items: [] },
          player: {
            auto_play: true,
            show_progress_bar: false,
            time_to_pitch: false,
            time_to_pitch_value: '',
            player_color: '#000000',
            progress_bar_color: '#FFFFFF',
          },
          tags: '',
          profileBtn: true,
        },
        zIndex: 1,
      },
    ];
  }
}
